import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { DirectPriceEditorModal } from '../components/DirectPriceEditorModal/DirectPriceEditorModal';
import { OfferCodeModal } from '../components/OfferCodeModal/OfferCodeModal';
import { TierLimitEditorModal } from '../components/TierLimitEditorModal/TierLimitEditorModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings, so they carry the module name: the registry throws on a
 * collision rather than letting whichever registered last silently win.
 */
export const SUBSCRIPTION_MODALS = {
  DIRECT_PRICE: 'subscriptions.direct-price',
  OFFER_CODE: 'subscriptions.offer-code',
  TIER_LIMIT: 'subscriptions.tier-limit',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * **The plan editor is deliberately not here.** It is a page: eleven fields in
 * three sections, both locales of two of them, and a price summary beside them —
 * the same reasoning that keeps the notification template editor out of a
 * dialog.
 *
 * The one dialog is opened by **string**, so neither the board nor the plan page
 * imports it (W2), and its payload is the plan's KEY plus its name. The key
 * rather than the id, because `billing.directPrices` is keyed by it and the
 * dialog writes a setting, not a product; the name only so the title reads as a
 * sentence, and it falls back to the key. `ModalData` is serializable-only,
 * which is why both travel rather than a row object.
 *
 * **The tier-limit editor's payload is the TIER**, a varchar an operator typed,
 * for the same reason: it is what `billing.tierLimits` is keyed by, and the
 * dialog writes a setting rather than a product.
 *
 * **The offer-code editor is ONE type for two acts.** Its payload is `{ id? }`,
 * and the dialog re-reads the row by id rather than being handed one: `ModalData`
 * is serializable-only, and a row carried through the store would be a second
 * copy of what the api already answers. An absent `id` is the create — which is
 * a genuinely different form (six fields against three), because the mapping's
 * identity is create-only by contract.
 */
export const subscriptionsModals: readonly ModalRegistration[] = [
  { modalTypes: [SUBSCRIPTION_MODALS.DIRECT_PRICE], component: DirectPriceEditorModal },
  { modalTypes: [SUBSCRIPTION_MODALS.OFFER_CODE], component: OfferCodeModal },
  { modalTypes: [SUBSCRIPTION_MODALS.TIER_LIMIT], component: TierLimitEditorModal },
];
